export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f580ff31b6c9fcb7f8f277bab2e2b6a20cc58dc8b&name=fetchTypeahead!'